<template>
  <div>
    <custom-callout class="mb-3 custom-callout">
      <div class="row border-bottom py-3 pb-4 m-0">
        <div class="col-md col-12">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Equipo:
          </div>
          <div class="color-black font-16 font-weight-bold">
            {{ item.equipmentName }}
          </div>
        </div>
        <div class="col-md col-12">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Requiere ser adquirido por el CAAT, por no estar disponibles en la
            escuela:
          </div>
          <div class="color-black font-16 font-weight-normal">
            Si
          </div>
        </div>
      </div>
      <div class="row py-3 pt-4 m-0">
        <div class="col-md-3 col-12">
          <div class="color-secondary-6 font-14 font-weight-normal">
            Clasificación de Cumplimiento:
          </div>
          <div class="color-black font-16 font-weight-normal">
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-drop-down
                fieldkey="id"
                fieldname="name"
                :disabled="isReadOnly || item.hasRequisition"
                placeholder="Seleccione"
                :options="classifications"
                v-model="item.classification"
                :error="errors[0]"
                custom-error-msg="La clasificación de cumplimiento es requerida"
              />
            </validation-provider>
          </div>
        </div>
        <div class="col-md-3 col-12">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Método de Compra:
          </div>
          <div class="color-black font-16 font-weight-normal">
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-drop-down
                fieldkey="id"
                fieldname="name"
                :disabled="isReadOnly || item.hasRequisition"
                placeholder="Seleccione"
                :options="purchaseMethods"
                v-model="item.purchaseMethod"
                :error="errors[0]"
                custom-error-msg="El método de compra es requerido"
              />
            </validation-provider>
          </div>
        </div>
        <div v-if="isInventory" class="col-md-3 col-12">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Tipo del Inventario:
          </div>
          <div class="color-black font-16 font-weight-normal mt-1">
            <b-form-group v-slot="{ ariaDescribedby }">
              <validation-provider v-slot="{ errors }" rules="required">
                <b-form-radio-group
                  :disabled="isReadOnly"
                  v-model="item.inventoryType"
                  :id="`radio-group-${item.key}`"
                  :name="`radio-options-${item.key}`"
                  :options="inventoryTypes"
                  :aria-describedby="ariaDescribedby"
                ></b-form-radio-group>
                <error
                  v-if="errors[0]"
                  variant="no-border"
                  message="El tipo del inventario es requerido."
                />
              </validation-provider>
            </b-form-group>
          </div>
        </div>
      </div>

      <template #edition>
        <div class="bg-light-gray">
          <custom-tab nav-class="nav-vue-underline" no-nav-style>
            <custom-tab-item title="Descripción del Equipo">
              <div class="p-4">
                {{ item.description }}
              </div>
            </custom-tab-item>
          </custom-tab>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import CustomDropDown from 'custom-drop-down';
import { CustomTab, CustomTabItem } from 'custom-tabs';
import mixAlert from '@/mixins/alert.mixin';
import purchaseMethod from '@/utils/constants/purchaseMethods';
import purchaseMethodInventoryTypes from '@/utils/constants/purchaseMethodInventoryTypes';
import { ValidationProvider } from 'vee-validate';
import error from 'custom-error';
export default {
  name: 'RequisitionAnalysisEquipmentRow',
  components: {
    CustomCallout,
    CustomDropDown,
    CustomTab,
    CustomTabItem,
    ValidationProvider,
    error,
  },
  mixins: [mixAlert],
  props: {
    item: {
      type: Object,
      required: true,
    },
    classifications: {
      type: Array,
      required: true,
    },
    purchaseMethods: {
      type: Array,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isInventory() {
      return this.item.purchaseMethod?.id === purchaseMethod.Inventory;
    },
    inventoryTypes() {
      return [
        {
          value: purchaseMethodInventoryTypes.New,
          text: 'Nuevo',
        },
        {
          value: purchaseMethodInventoryTypes.Used,
          text: 'Usado',
        },
        {
          value: purchaseMethodInventoryTypes.Auction,
          text: 'Subasta',
        },
      ];
    },
  },
};
</script>
<style lang="scss"></style>
